import * as React from 'react';
import { FormSectionNewsLetter } from '../../form/FormSectionNewsLetter';

/* NEWSLETTER */

export const NewsLetter: React.FC = () => {
  return (
    <>
      <FormSectionNewsLetter mailType={27} />
    </>
  );
};
